<template>
  <div>
    <!-- <teacher-lookup :showAddTeacherLink="true" v-model="teacher" :required="true" /> -->
    <v-checkbox
      v-if="schedules && schedules.length > 0"
      v-model="hideCancelled"
      label="Hide canceled schedules"
    />

    <div v-if="teacher">
      <div class="text-caption" v-if="!schedules || schedules.length < 1">
        No schedule found for {{ teacher.firstName }}

        <div class="text-center ma-5">
          <v-btn text @click="newTeacherSchedule"> Add New Schedule </v-btn>
        </div>
      </div>
      <div v-else>
        <div
          class="d-flex flex-column-reverse flex-md-row justify-space-between"
        >
          <div class="text-subtitle-2 mb-4">
            {{ teacher.firstName }} {{ teacher.lastName }}'s Active Schedules
          </div>
          <div class="ml-auto mb-2 text-right d-flex">
            <a @click="newTeacherSchedule"> Add New Schedule </a>
          </div>
        </div>

        <!-- <div class="mb-2" v-for="schedule in schedules" :key="schedule.id">
          <span> {{ getCenterName(schedule.centerId) }} </span>
          <div>
            {{ schedule.startDate | formatDate }}
            <span v-if="schedule.recurring">
              -
              {{
                schedule.endDate
                  ? ` ${$options.filters.formatDate(schedule.endDate)}`
                  : " no end date"
              }}
            </span>
          </div>
          <div>
            {{
              schedule.recurring
                ? `Every ${schedule.recurringDays.join(", ")},`
                : ""
            }}
            {{ schedule.startTime }} -
            {{ schedule.endTime }}
          </div>

          <div v-if="schedule2Course[schedule.id]">
            <a @click="viewCourse(schedule2Course[schedule.id])">
              {{ schedule2Course[schedule.id].name }}
            </a>
          </div>

          <div class="text-end text-caption">
            Created on {{ schedule.createdOn | formatDate }}
          </div>

          <v-divider />
        </div> -->

        <v-tabs
          v-model="tab"
          background-color="white"
          color="blue"
          :show-arrows="false"
        >
          <v-tab key="active">Active Schedules</v-tab>
          <v-tab key="past">Past Schedules</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="active">
            <div
              class="text-caption my-4"
              v-if="!schedules || schedules.length < 1"
            >
              No active schedule found for {{ teacher.firstName }}
            </div>
            <div v-else>
              <teacher-schedule-timeline
                v-if="loaded"
                v-model="schedules"
                @on-edit="editSchedule"
                @on-undo-cancellation="undoCancellation"
                :scheduleExclusionDates="scheduleExclusionDates"
                :hideCancelled="hideCancelled"
                :key="componentKey"
              />

              <v-skeleton-loader
                v-else
                type="list-item, list-item-two-line, list-item, list-item-two-line"
              />
            </div>
          </v-tab-item>

          <v-tab-item key="past">
            <div
              class="text-caption my-4"
              v-if="!schedules || schedules.length < 1"
            >
              No past schedule found for {{ student.firstName }}
            </div>
            <div v-else>
              <teacher-schedule-timeline
                v-if="loaded"
                v-model="schedules"
                :showPastDates="true"
                @on-edit="editSchedule"
                @on-undo-cancellation="undoCancellation"
                :scheduleExclusionDates="scheduleExclusionDates"
                :hideCancelled="hideCancelled"
                :key="componentKey"
              />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
    <div v-else class="text-caption">Please choose a teacher first</div>
  </div>
</template>

<script>
import dialogMixin from "@/components/schedule/dialogMixin.js";

import moment from "moment";
import { mapGetters } from "vuex";
import {
  fetchTeacherSchedulesByTeacherIds,
  getScheduleExclusionDates,
  undoCancelOccurrence,
} from "@/services/teacherScheduleService.js";
import {
  openNewTeacherSchedule,
  openEditTeacherScheduleInstance,
} from "@/components/schedule/eventHandler.js";
const TeacherScheduleTimeline = () =>
  import("@/components/teacher/TeacherScheduleTimeline");
import { EventBus } from "@/EventBus.js";
import { mapActions } from "vuex";

export default {
  mixins: [dialogMixin],
  components: { TeacherScheduleTimeline },
  props: {
    value: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    loaded: false,
    tab: "active",
    teacher: null,
    schedules: [],
    schedule2Course: {},
    scheduleExclusionDates: [],
    hideCancelled: true,
    componentKey: 0,
  }),
  computed: {
    ...mapGetters(["globalCenter", "myCenters", "getCenterName"]),
  },

  watch: {
    teacher(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchSchedule(newVal);
        this.componentKey += 1;
      }
    },
  },
  mounted() {
    this.teacher = this.value;
  },
  created() {
    EventBus.$on("reload-dialog", (uuID, instructions) => {
      //The containing dialog is the main component
      if (uuID == this.uuID) {
        debugger;
        const action = instructions.action;
        const scheduleIds = this.schedules.map((s) => s.id);
        // const schedule = instructions.schedule;

        // Define an async function
        const executeAction = async () => {
          if (action === "deleted") {
            this.scheduleExclusionDates = await getScheduleExclusionDates(
              scheduleIds
            );
            this.hideCancelled = false;
          } else if (action === "updated") {
            // TODO implement
          } else if (action === "added") {
            // TODO implement
          }
        };

        // Call the async function
        executeAction();
      }
    });
  },
  beforeDestroy() {
    // to avoid memory leaks
    EventBus.$off("reload-dialog");
  },
  methods: {
    ...mapActions([
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
      "clearMessage",
    ]),

    undoCancellation(scheduleId, scheduleDate) {
      undoCancelOccurrence(scheduleId, scheduleDate)
        .then(async () => {
          const scheduleIds = this.schedules.map((s) => s.id);
          this.scheduleExclusionDates = await getScheduleExclusionDates(
            scheduleIds
          );
        })
        .catch((error) => {
          this.addErrorMessage(
            error.data.message || "Error restoring canceled schedule"
          );
        });
    },
    editSchedule(date, schedule) {
      const startTime = `${date} ${moment(schedule.startTime).format("HH:mm")}`;
      const endTime = `${date} ${moment(schedule.endTime).format("HH:mm")}`;

      const teacherSchedule = {
        id: schedule.id,
        scheduleId: schedule.id,
        teacherFirstName: this.teacher.firstName,
        teacherLastName: this.teacher.lastName,
        teacherId: schedule.teacherId,
        startTime,
        endTime,
        partOfRecurring: schedule.recurring,
        recurringDays: schedule.recurringDays,
        recurringStartDate: schedule.recurring ? schedule.startDate : null,
        recurringEndDate: schedule.recurringEndDate,
        programId: schedule.programId,
        centerId: schedule.centerId,
        notes: schedule.notes,
      };

      openEditTeacherScheduleInstance({ teacherSchedule, parentID: this.uuID });
    },
    fetchSchedule(teacher) {
      const teacherIds = [teacher.id];

      fetchTeacherSchedulesByTeacherIds(teacherIds).then(async (data) => {
        this.schedules = data.map((d) => {
          const startTime = moment(d.startDate + "T" + d.startTime);
          const endTime = moment(d.startDate + "T" + d.endTime);
          return {
            id: d.id,
            teacherFirstName: teacher.firstName,
            teacherLastName: teacher.lastName,
            startTime: startTime,
            endTime: endTime,
            teacherId: d.teacherId,
            recurring: d.recurring,
            recurringDays: d.recurringDays,
            startDate: d.startDate,
            endDate: d.endDate,
            courseScheduleId: d.courseScheduleId,
            centerId: d.centerId,
          };
        });

        const scheduleIds = this.schedules.map((s) => s.id);

        this.scheduleExclusionDates = await getScheduleExclusionDates(
          scheduleIds
        );
        this.schedule2Course = await this.fetchCourseInfo(scheduleIds);

        this.loaded = true;
      });
    },
    async fetchCourseInfo(scheduleIds) {
      if (scheduleIds) {
        const params = {
          teacher_schedule_ids: scheduleIds ? scheduleIds.join(",") : null,
        };
        return await this.$axios(
          "/teacher-schedule/courses-with-teacher-schedules",
          {
            params,
          }
        ).then((resp) => {
          return resp.data;
        });
      }
    },
    viewCourse(course) {
      let route = this.$router.resolve({ path: "/secure/course/" + course.id });
      window.open(route.href, "_blank");
    },
    newTeacherSchedule() {
      openNewTeacherSchedule({ teacher: this.teacher });
    },
  },
};
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}
</style>